import { render, staticRenderFns } from "./DesktopMobileAppNotice.vue?vue&type=template&id=2c2cc856&scoped=true"
import script from "./DesktopMobileAppNotice.vue?vue&type=script&lang=js"
export * from "./DesktopMobileAppNotice.vue?vue&type=script&lang=js"
import style0 from "./DesktopMobileAppNotice.vue?vue&type=style&index=0&id=2c2cc856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2cc856",
  null
  
)

export default component.exports